import apiHelper from "../../utilities/apiObsHelpers";
import {
  apiLoadSelectedUser,
  apiLoadUsers,
  apiRegisterUser,
  apiUpdateUser,
  apiLoadFeatures,
  apiLoadRoleNames,
  apiLoadRoles,
  apiUpdateRoles
} from "../api/apiObservables";

import clone from 'lodash/clone'

export const ACTION_ADD_USER           = 'admin/actionAddUser';
export const ACTION_EDIT_USER          = 'admin/actionEditUser';
export const ACTION_LOAD_USERS         = 'admin/actionLoadUsers';
export const ACTION_LOAD_SELECTED_USER = 'admin/actionLoadUserById';

export const ACTION_LOAD_FEATURES      = 'admin/actionLoadFeatures';
export const ACTION_LOAD_ROLES_NAMES   = 'admin/actionLoadRoleNames';
export const ACTION_LOAD_ROLES         = 'admin/actionLoadRoles';
export const ACTION_UPDATE_ROLES       = 'admin/actionUpdateRoles';

export const GETTER_USERS              = 'admin/getAllUsers';
export const GETTER_SELECTED_USER      = 'admin/getSelectedUser';
export const GETTER_FEATURES           = 'admin/getFeatures';
export const GETTER_ROLE_NAMES         = 'admin/getRoleNames';
export const GETTER_ROLES              = 'admin/getRoles';

export const MUTATION_SET_USERS           = 'admin/setAllUsers';
export const MUTATION_SET_SELECTED_USERS  = 'admin/setSelectedUser';
export const MUTATION_SET_FEATURES        = 'admin/setFeatures';
export const MUTATION_SET_ROLE_NAMES      = 'admin/setRoleNames';
export const MUTATION_SET_ROLES           = 'admin/setRoles';

const state = {
  users        : {},
  selectedUser : {},
  features     : [],
  roleNames    : [],
  roles        : []
};

const getters = {
  [GETTER_USERS]         : (state) => state.users,
  [GETTER_SELECTED_USER] : (state) => state.selectedUser,
  [GETTER_FEATURES]      : (state) => state.features,
  [GETTER_ROLE_NAMES]    : (state) => state.roleNames,
  [GETTER_ROLES]         : (state) => state.roles
};

const mutations = {
  [MUTATION_SET_USERS]: (state, payload) => {
    state.users = Object.assign({}, payload)
  },
  [MUTATION_SET_SELECTED_USERS]: (state, payload) => {
    state.selectedUser = Object.assign({}, payload)
  },
  [MUTATION_SET_FEATURES]: (state, payload) => {
    state.features = clone(payload);
  },
  [MUTATION_SET_ROLE_NAMES]: (state, payload) => {
    state.roleNames = clone(payload);
  },
  [MUTATION_SET_ROLES]: (state, payload) => {
    state.roles = clone(payload);
  }
};

const actions = {
  [ACTION_ADD_USER]:   apiHelper.mutateResult(apiRegisterUser),
  [ACTION_EDIT_USER]:  apiHelper.mutateResult(apiUpdateUser),
  [ACTION_LOAD_USERS]: apiHelper.mutateResult(
    apiLoadUsers,
    MUTATION_SET_USERS),
  [ACTION_LOAD_SELECTED_USER]: apiHelper.mutateResult(
    apiLoadSelectedUser,
    MUTATION_SET_SELECTED_USERS),
  [ACTION_LOAD_FEATURES]: apiHelper.mutateResult(
    apiLoadFeatures,
    MUTATION_SET_FEATURES),
  [ACTION_LOAD_ROLES_NAMES]: apiHelper.mutateResult(
    apiLoadRoleNames,
    MUTATION_SET_ROLE_NAMES),
  [ACTION_LOAD_ROLES]: apiHelper.mutateResult(
    apiLoadRoles,
    MUTATION_SET_ROLES),
  [ACTION_UPDATE_ROLES] : apiHelper.mutateResult(apiUpdateRoles)
};

export default {
  state,
  getters,
  mutations,
  actions
}
